import {RootStore} from './RootStore';
import {SPECS} from '../../../specs';

export type ReportPanoramaTransactionFn = (interaction: string, fn: () => unknown) => Promise<void>;

export type ReportPanoramaFn = (rootStore: RootStore) => ReportPanoramaTransactionFn;

export const createReportPanoramaTransaction: ReportPanoramaFn =
  (rootStore) =>
  async (interaction, fn): Promise<any> => {
    const isPanoramaEnabled = rootStore.controllerParams.flowAPI.experiments.enabled(SPECS.EnablePanoramaIntegration);
    const panoramaClient = isPanoramaEnabled ? rootStore.controllerParams.flowAPI.panoramaClient : null;
    const panoramaTransaction = panoramaClient?.transaction(interaction);

    panoramaTransaction?.start();

    const result = await fn();

    panoramaTransaction?.finish();

    return result;
  };
